export default "__VITE_ASSET__CPPz4em4__"